<template>
    <main class="main-content">
        <section class="profile-section">
            <h2>User Info</h2>
            <div class="form-group">
                <label for="username">Username</label>
                <input type="username" id="username" v-model="username" readonly />
            </div>
            <div class="form-group">
                <label for="email">Email</label>
                <input type="email" id="email" v-model="email" readonly />
            </div>
        </section>
    </main>
</template>
<script>
import { getUser } from '@/api/users'
export default {
    name: 'UserProfileView',
    setup() {
        const user = getUser();
        const username = user.username;
        const email = user.email;
        return {
            username,
            email
        };
    },
    methods: {
    }
};
</script>

<style scoped>
.main-content {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin: 1rem;
    margin-left: 2rem;
    margin-right: 2rem;
}


.profile-section {
    margin-bottom: 2rem;
}

.profile-section:last-child {
    margin-bottom: 0;
}

.form-group {
    margin-bottom: 1.5rem;
}

.form-group label {
    display: block;
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: var(--text-primary);
}

.form-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    font-size: 1rem;
    font-family: 'Inter', sans-serif;
}

.form-group input:focus {
    outline: none;
    border-color: var(--accent-indigo);
    box-shadow: 0 0 0 3px #F4F3FF;
}

@media (max-width: 768px) {
    .main-content {
        gap: 1.5rem;
    }

}
</style>